import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { Box, Button, Grid, Hidden } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { MUIBlock, CourseCard, GridContainer } from "../../MUI";
import * as styles from "./styles.scss";
import cx from "classnames";
import { SvgIcon } from "../../../../components";
import { StickyContainer, Sticky } from "react-sticky";

import { RightPanel } from "./RightPanel";
import { Head } from "./Head";
import { TabsList } from "./Tabs";
import { FiltersPanel } from "./FiltersPanel";
import { FileslistsGroupsList } from "./FileslistsGroupsList";
import { FilesList } from "./Fileslist";
import { AttachPanel } from "./AttachPanel";
import { tl } from "../../../../utils";

import { ICourse } from "../types";
import { TranscriptionInfoPopup } from "../../../../components/TranscriptionInfoPopup";

export const Course = observer(() => {
  const { fsStore, fsCourseStore } = React.useContext(MobXProviderContext);
  const theme = useTheme();
  const [showTsInfo, setShowTsInfo] = React.useState(false);

  const course: ICourse = {
    id: fsStore.course_id,
    icon: fsStore.course_cover,
    name: fsStore.course_name,
    title: ''
  };

  if (!fsStore.isWidget) {
    document.querySelector("body").classList.remove("no1200step");
  }
  const courseBody = (
    <MUIBlock
      className={fsStore.isWidget ? styles.asWidget : null}
      // data={{ style: { overflow: "hidden" } }}
      pInner={0}
    >
      <Head />
      {!!fsCourseStore.isHaveFilesInCourse && <TabsList />}
      <StickyContainer>
        {!!fsCourseStore.isHaveFilesInCourse && (
          <Sticky topOffset={fsStore.isWidget ? 0 : -42}>
            {({ style, isSticky }) => (
              <div>
                <FiltersPanel
                  style={style}
                  isStuck={isSticky}
                  key={fsCourseStore.getFilterKey}
                />
              </div>
            )}
          </Sticky>
        )}
        {fsStore.rootStore.fsCourseStore.filterFilesType === 'transcription' ? (
          <span style={{fontSize: 16, padding: 13, display: 'inline-block'}}>Выберите видео для которого нужна транскрибация</span>
        ) : (
          <>
            <Box className={styles.messages}>
              <Box className={`${styles.message} ${styles.newFeature}`}>
                <span>
                  <strong>Новинка!</strong> Транскрибируйте ваши видео сразу после загрузки и получайте литературный текст с помощью AI для ваших учеников. <strong onClick={() => {setShowTsInfo(true); fsStore.onCancel();}} style={{textDecoration: 'underline', cursor: 'pointer'}}>Подробнее</strong>
                </span>
              </Box>
            </Box>
            <TranscriptionInfoPopup open={showTsInfo} onClose={() => setShowTsInfo(false)}></TranscriptionInfoPopup>
          </>
        )}
        <Box
          flex={1}
          {...(fsStore.isWidget || fsCourseStore.isFileslistCarded
            ? null
            : { mb: 1 })}
          className={cx({
            [styles.list]: true,
            [styles.listCarded]: fsCourseStore.isFileslistCarded,
          })}
        >
          {fsCourseStore.isFileslistGrouped ? (
            <FileslistsGroupsList
              key={fsCourseStore.getFileslistAPIUrl}
              APIUrl={fsCourseStore.getFileslistAPIUrl}
            />
          ) : (
            <FilesList
              key={fsCourseStore.getFileslistAPIUrl + fsStore.salt}
              APIUrl={fsCourseStore.getFileslistAPIUrl}
              scrollerUseWindow={true}
            />
          )}
        </Box>
        {(fsStore.onAttach || fsStore.onProtect  || fsStore.canDelete &&
          fsStore.getCheckedFilesCount) || fsCourseStore.filesSectionTab === 'notinlessons' ? (
          <AttachPanel />
      ) : null}
      </StickyContainer>

    </MUIBlock>
  );
  return fsStore.isWidget ? (
    courseBody
  ) : (
    <div className="wrap mainwrap">
      <GridContainer direction="row-reverse" spacing={2}>
        {!fsStore.isWidget ? <RightPanel /> : null}
        <Grid item className={styles.wrap}>
          {!fsStore.isWidget && (
            <MUIBlock
              mb={2}
              pInner={0}
              data={{ style: { overflow: "hidden" } }}
            >
              <Box bgcolor={theme.palette.grey.A100} clone>
                <Grid container>
                  <Hidden only="xs">
                    <Box
                      display="flex"
                      bgcolor={theme.palette.background.paper}
                      clone
                      className={styles.back}
                    >
                      <Grid item zeroMinWidth>
                        <Box p={2} clone>
                          <Grid container onClick={fsStore.onChangeCourse}>
                            <Box
                              bgcolor={theme.palette.grey.A200}
                              borderRadius={theme.shape.borderRadius}
                              clone
                              className={styles.backIcon}
                            >
                              <Grid item>
                                <SvgIcon type="fs-back" />
                              </Grid>
                            </Box>
                            <Box
                              alignSelf="center"
                              clone
                              className={styles.backText}
                            >
                              <Grid item>
                                {tl("Другие")} <br />
                                {tl("курсы")}
                              </Grid>
                            </Box>
                          </Grid>
                        </Box>
                      </Grid>
                    </Box>
                  </Hidden>
                  <Box
                    display="flex"
                    bgcolor={theme.palette.background.paper}
                    clone
                    className={styles.course}
                  >
                    <Grid
                      item
                      xs
                      component="a"
                      href={`/${fsStore.module}/${fsStore.course_id}/lessons`}
                      target="_blank"
                    >
                      <Box flex="1" display="flex" p={2}>
                        <Grid container spacing={2} alignItems="center">
                          <CourseCard course={course} big />
                          <Hidden only="xs">
                            <Grid item>
                              <Box
                                color={theme.palette.primary.light}
                                fontWeight={600}
                                clone
                                className={styles.courseGo}
                              >
                                <Grid container alignItems="center">
                                  {tl("В курс")}
                                  <SvgIcon type="fs-gotocourse" />
                                </Grid>
                              </Box>
                            </Grid>
                          </Hidden>
                        </Grid>
                      </Box>
                    </Grid>
                  </Box>
                </Grid>
              </Box>
              <Hidden smUp>
                <Box p={2} pt={0}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={fsStore.onChangeCourse}
                  >
                    {tl("Файлы других курсов")}
                  </Button>
                </Box>
              </Hidden>
            </MUIBlock>
          )}
          {courseBody}
        </Grid>
      </GridContainer>
    </div>
  );
});
